import { usePollContext } from '../../../../Context';
import { getIsPollOpen } from '../../../helpers';

const useManualPoll = () => {
  const { poll } = usePollContext();

  const isPollOpen = getIsPollOpen(poll);

  return { isPollOpen };
};

export default useManualPoll;
